// src/components/portfolio/add-asset/services/SearchService.js
import { BistService } from './BistService';
import { TefasService } from './TefasService';

export class SearchService {
  static async searchCurrencies(query) {
    const currencies = [
      { symbol: 'USD', name: 'Amerikan Doları', currencySymbol: '$' },
      { symbol: 'EUR', name: 'Euro', currencySymbol: '€' },
      { symbol: 'GBP', name: 'İngiliz Sterlini', currencySymbol: '£' },
      { symbol: 'TRY', name: 'Türk Lirası', currencySymbol: '₺' },
      { symbol: 'JPY', name: 'Japon Yeni', currencySymbol: '¥' },
      { symbol: 'CHF', name: 'İsviçre Frangı', currencySymbol: 'Fr' },
      { symbol: 'AUD', name: 'Avustralya Doları', currencySymbol: 'A$' },
      { symbol: 'CAD', name: 'Kanada Doları', currencySymbol: 'C$' }
    ];
    
    return currencies.filter(curr => 
      curr.symbol.toLowerCase().includes(query.toLowerCase()) || 
      curr.name.toLowerCase().includes(query.toLowerCase())
    );
  }

  static async searchLocal(searchQuery, db, searchMode) {
    if (searchQuery.length < 2) return [];

    try {
      switch (searchMode) {
 
        case 'fund':
          return await TefasService.searchFunds(searchQuery);
        case 'local':
          return await BistService.searchStocks(searchQuery);
        case 'api':
          return await this.searchFMP(searchQuery);
        default:
          return [];
      }
    } catch (error) {
      console.error('Arama hatası:', error);
      return [];
    }
  }

  static async searchFMP(query) {
    if (query.length < 2) return [];

    try {
      const response = await fetch(
        `https://financialmodelingprep.com/api/v3/search?query=${query}&apikey=WL87p2yvv8LNLtG8tpwSooErlRWgvgzU`
      );

      if (!response.ok) {
        throw new Error('FMP API yanıt vermedi');
      }

      const data = await response.json();
      
      return data
        .filter(item => item.exchangeShortName && item.exchangeShortName !== 'IS')
        .map(item => ({
          symbol: item.symbol,
          name: item.name,
          type: 'STOCK',
          exchange: item.exchangeShortName,
          description: item.name
        }))
        .slice(0, 10);
    } catch (error) {
      console.error('FMP API hatası:', error);
      return [];
    }
  }
}